import { render, staticRenderFns } from "./whd_menu.vue?vue&type=template&id=47e55cdf&lang=pug&"
import script from "./whd_menu.vue?vue&type=script&lang=js&"
export * from "./whd_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports